<template>
  <div class="meditationlibrary container-fluid">
    <div class="container-fluid">
      <div class="row mx-0">
        <div class="col-md-12 px-0">
          <div class="card card-transparent-background">
            <div class="card-header row p-0">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">
                  Meditation Library
                </h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <b-tabs class="evnetTypesTabs">
              <b-tab
                title="Video"
                active
                title-link-class="btn btn-tab btn-doomyoga-secondary"
              >
                <VideoCategoryList ref="videoCategoryListMed"
              /></b-tab>
              <b-tab
                title="Audio"
                title-link-class="btn btn-tab btn-doomyoga-secondary"
                ><AudioCategoryList ref="audioCategoryListMed"
              /></b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <save-category
      :category="modal_category"
      :type="modal_type"
      client_name="DY"
      :title="save_category_modal_title"
      :action_type="save_category_action_type"
      :category_id="selected_category_id"
      :category_title="selected_category_title"
      :category_description="selected_category_description"
    />
    <!-- delete modal -->
    <DeleteCategory
      :media_type="modal_category"
      :sub_media_type="modal_type"
      :client_name="client_name"
      :category_id="selected_category_id"
    />
    <!-- end delete modal-->
  </div>
</template>

<script>
import AudioCategoryList from "./AudioCategoryList.vue";
import VideoCategoryList from "./VideoCategoryList.vue";
import SaveCategory from "../media/SaveCategory.vue";
import DeleteCategory from "../media/DeleteCategory.vue";

export default {
  name: "MeditationLibrary",
  components: { SaveCategory, AudioCategoryList, VideoCategoryList , DeleteCategory},
  data() {
    return {
      client_name:"DY",
      modal_category: "meditation_library",
      modal_type: "",
      save_category_modal_title: "Add New Category",
      selected_category_id: null,
      selected_category_title: null,
      selected_category_description: null,
      save_category_action_type: "add",
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    clickAddCategory(modal_type) {
      console.log("in click add category");
      this.modal_type = modal_type;
      this.save_category_modal_title = "Add New Category";
      this.save_category_action_type = "add";
      this.selected_category_id = null;
      this.selected_category_title = null;
      this.selected_category_description = null;
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
    },
    clickEditCategory(id, title, description, modal_type) {
      console.log("in click edit category");
      console.log(id, title, description);
      this.modal_type = modal_type;
      this.save_category_modal_title = "Category Info";
      this.save_category_action_type = "edit";
      this.selected_category_id = id;
      this.selected_category_title = title;
      if (description == null || description == "null") {
        this.selected_category_description = null;
      } else {
        this.selected_category_description = description;
      }
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
      // $('#saveCategoryModal').modal('show')
    },
    clickDeleteCategory(id, modal_type) {
      console.log("click delete category", id);
      this.selected_category_id = id;
      this.modal_type = modal_type;

      this.$root.$emit("bv::show::modal", "deleteCategoryModal");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/meditation_library/Index.vue